<template>
  <div class="halaman-admin">
    <div>
      <!-- Bootstrap Modal Single Delete -->
      <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Konfirmasi Hapus</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              Apakah Anda yakin ingin menghapus data atlet ini?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
              <button type="button" class="btn btn-danger" @click="deleteData">Ya, hapus</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Bootstrap Modal Bulk Delete -->
      <div class="modal fade" id="confirmBulkDeleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-danger">
                <i class="bi bi-exclamation-triangle-fill me-1"></i> Konfirmasi Hapus Sekaligus
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              Apakah Anda yakin ingin menghapus <strong>{{ selectedMemberIds.length }}</strong> atlet yang dipilih? Tindakan ini tidak dapat dibatalkan.
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Batal</button>
              <button type="button" class="btn btn-danger btn-sm" :disabled="bulkDeleting" @click="deleteBulkData">
                <span v-if="bulkDeleting" class="spinner-border spinner-border-sm me-1"></span>
                <i v-else class="bi bi-trash-fill me-1"></i> Ya, Hapus Semua
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-container">
      <div
        v-if="loading"
        class="progress-bar"
        :style="{ width: progress + '%' }"
      ></div>

      <!-- Header & Page Actions -->
      <div class="header-section mb-4">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div>
            <h4 class="page-main-title mb-1">
              <i class="bi bi-people-fill text-primary me-2"></i>Data Atlet
            </h4>
            <p class="text-muted mb-0 small">
              Kelola seluruh data atlet, kategori pertandingan, dan status verifikasi kontingen Anda.
            </p>
          </div>

          <div class="d-flex flex-wrap gap-2">
            <button
              v-if="isPanitia"
              type="button"
              class="btn btn-outline-danger btn-sm d-flex align-items-center gap-1.5 shadow-sm fw-medium"
              @click="bukaCetakIdCard"
              title="Cetak lembar ID Card massal A4 beserta QR Code untuk atlet"
            >
              <i class="bi bi-person-badge"></i>
              <span>Cetak ID Card Massal</span>
            </button>

            <button
              v-if="daftarPermissions.includes('export member')"
              class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1.5 shadow-sm fw-medium"
              :disabled="loading"
              @click="exportToExcel"
            >
              <i class="bi bi-file-earmark-excel text-success"></i>
              <span>Ekspor Excel</span>
            </button>

            <router-link
              to="/admin/team-members/impor"
              class="btn btn-outline-primary btn-sm d-flex align-items-center gap-1.5 shadow-sm fw-medium"
            >
              <i class="bi bi-file-earmark-arrow-up"></i>
              <span>Impor Excel</span>
            </router-link>

            <router-link
              to="/admin/team-members/create"
              class="btn btn-primary btn-sm d-flex align-items-center gap-1.5 shadow-sm text-white fw-medium"
            >
              <i class="bi bi-person-plus-fill"></i>
              <span>Tambah Atlet</span>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Modern Filter Card -->
      <div class="modern-filter-card mb-4">
        <div class="filter-header d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div class="d-flex align-items-center gap-2">
            <div class="filter-icon-box">
              <i class="bi bi-sliders2 text-primary"></i>
            </div>
            <div>
              <span class="filter-title fw-semibold">Filter Data Atlet</span>
              <span v-if="activeFilterCount > 0" class="badge bg-primary-subtle text-primary rounded-pill ms-2">
                {{ activeFilterCount }} Filter Aktif
              </span>
            </div>
          </div>

          <div class="d-flex align-items-center gap-2">
            <button
              v-if="activeFilterCount > 0 || searchQuery"
              type="button"
              class="btn btn-link btn-sm text-decoration-none text-danger p-0 d-flex align-items-center gap-1"
              @click="resetFilter"
            >
              <i class="bi bi-arrow-counterclockwise"></i> Reset Filter
            </button>
          </div>
        </div>

        <!-- Filter Grid Selects -->
        <div class="row g-3">
          <!-- Turnamen -->
          <div class="col-12 col-md-6 col-lg-4">
            <div class="filter-field">
              <label class="filter-label">
                <i class="bi bi-trophy text-muted me-1"></i>Turnamen
              </label>
              <select
                v-model="form.tournament_id"
                @change="fetchMatchCategories"
                class="form-select filter-select"
              >
                <option value="">Semua Turnamen</option>
                <option v-for="t in tournaments" :key="t.id" :value="t.id">{{ t.name }}</option>
              </select>
            </div>
          </div>

          <!-- Kategori Pertandingan -->
          <div class="col-12 col-md-6 col-lg-4">
            <div class="filter-field">
              <label class="filter-label">
                <i class="bi bi-tags text-muted me-1"></i>Kategori
              </label>
              <select
                v-model="form.match_category_id"
                @change="fetchAgeCategories"
                class="form-select filter-select"
                :disabled="!form.tournament_id && matchCategories.length === 0"
              >
                <option value="">Semua Kategori</option>
                <option v-for="cat in matchCategories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
              </select>
            </div>
          </div>

          <!-- Kategori Usia -->
          <div class="col-12 col-md-6 col-lg-4">
            <div class="filter-field">
              <label class="filter-label">
                <i class="bi bi-person-badge text-muted me-1"></i>Kategori Usia
              </label>
              <select
                v-model="form.age_category_id"
                @change="fetchCategoryClasses"
                class="form-select filter-select"
                :disabled="!form.match_category_id && ageCategories.length === 0"
              >
                <option value="">Semua Usia</option>
                <option v-for="cat in ageCategories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
              </select>
            </div>
          </div>

          <!-- Kelas Tanding / Nomor -->
          <div class="col-12 col-md-6 col-lg-6">
            <div class="filter-field">
              <label class="filter-label">
                <i class="bi bi-diagram-3 text-muted me-1"></i>Kelas Tanding / Nomor
              </label>
              <select
                v-model="form.category_class_id"
                @change="loadTeamMembers"
                class="form-select filter-select"
                :disabled="!form.age_category_id && categoryClasses.length === 0"
              >
                <option value="">Semua Kelas</option>
                <option v-for="cc in categoryClasses" :key="cc.id" :value="cc.id">
                  {{ labelJK(cc.gender) }} - Kelas {{ cc.name }} ({{ cc.weight_min }}–{{ cc.weight_max }} kg)
                </option>
              </select>
            </div>
          </div>

          <!-- Status Pembayaran -->
          <div class="col-12 col-md-6 col-lg-6">
            <div class="filter-field">
              <label class="filter-label">
                <i class="bi bi-credit-card text-muted me-1"></i>Status Pembayaran
              </label>
              <select
                v-model="form.payment_status"
                @change="() => { currentPage = 1; loadTeamMembers(); }"
                class="form-select filter-select"
              >
                <option value="">Semua Status Pembayaran</option>
                <option value="paid">Lunas (Paid)</option>
                <option value="unpaid">Belum Lunas (Unpaid)</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Quick Search Bar inside Filter Card -->
        <div class="filter-search-wrapper mt-3 pt-3">
          <div class="row align-items-center g-2">
            <div class="col-12 col-md-8">
              <div class="search-input-group">
                <i class="bi bi-search search-icon text-muted"></i>
                <input
                  v-model="searchQuery"
                  type="text"
                  class="form-control search-input"
                  placeholder="Cari nama atlet, kontingen, atau nomor..."
                  @input="searchMembers"
                />
                <button
                  v-if="searchQuery"
                  type="button"
                  class="btn btn-link btn-clear-search text-muted p-0"
                  @click="clearSearch"
                >
                  <i class="bi bi-x-circle-fill"></i>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-md-end text-muted small">
              <span v-if="loading">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                Memuat data...
              </span>
              <span v-else>
                Total: <strong class="text-primary">{{ members.length }}</strong> atlet ditampilkan
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Bulk Actions Bar -->
      <div v-if="selectedMemberIds.length > 0" class="alert alert-danger d-flex align-items-center justify-content-between py-2 px-3 mb-3 rounded-3 shadow-sm">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-check2-square fs-5 text-danger"></i>
          <span class="fw-semibold text-danger">
            {{ selectedMemberIds.length }} atlet dipilih
          </span>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm" @click="selectedMemberIds = []">
            Batal Pilih
          </button>
          <button type="button" class="btn btn-danger btn-sm d-flex align-items-center gap-1" @click="confirmBulkDelete">
            <i class="bi bi-trash-fill"></i> Hapus Sekaligus ({{ selectedMemberIds.length }})
          </button>
        </div>
      </div>

      <!-- Table to display athlete data -->
      <div class="table-responsive modern-table-card shadow-sm rounded-3">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3" style="width: 44px;">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isAllSelected"
                  :indeterminate.prop="isIndeterminate"
                  @change="toggleSelectAll"
                  :disabled="deletableMembers.length === 0"
                  title="Pilih semua yang dapat dihapus di halaman ini"
                />
              </th>
              <th style="width: 50px;">No</th>
              <th style="min-width: 130px;">Turnamen</th>
              <th style="min-width: 110px;">Kontingen</th>
              <th style="min-width: 160px;">Nama Atlet</th>
              <th>Kategori</th>
              <th>Usia</th> 
              <th style="min-width: 110px;">Kelas / Nomor</th>        
              <th>Status Bayar</th>
              <th class="text-end pe-3" style="width: 80px;">Aksi</th>
            </tr>
          </thead>
          <tbody v-if="members.length > 0">
            <tr v-for="(member, index) in members" :key="member.id" class="table-row-hover" :class="{ 'table-active': selectedMemberIds.includes(member.id) }">
              <td class="ps-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :value="member.id"
                  v-model="selectedMemberIds"
                  :disabled="!bisaHapusMember(member)"
                  :title="!bisaHapusMember(member) ? 'Atlet yang sudah lunas tidak dapat dihapus' : 'Pilih atlet'"
                />
              </td>
              <td class="text-muted">{{ index + 1 + (currentPage - 1) * perPage }}</td>
              <td>
                <div class="fw-medium text-dark text-truncate" style="max-width: 220px;" :title="member.tournament_name">
                  {{
                    member.tournament_name ||
                    (member.contingent?.tournament_contingents || member.contingent?.tournamentContingents)
                      ?.map(tc => tc.tournament?.name)
                      .filter(Boolean)
                      .join(', ') ||
                    '-'
                  }}
                </div>
              </td>
              <td>
                <span class="fw-semibold text-secondary">{{ member.contingent?.name || '-' }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div class="avatar-circle overflow-hidden">
                    <img v-if="member.photo_url" :src="member.photo_url" alt="Foto" class="w-100 h-100" style="object-fit: cover;" />
                    <span v-else>{{ (member.name || 'A').charAt(0).toUpperCase() }}</span>
                  </div>
                  <div>
                    <span class="fw-bold text-dark d-block">{{ member.name }}</span>
                    <small class="text-muted" v-if="member.gender">{{ member.gender === 'male' || member.gender === 'L' ? 'Putra' : 'Putri' }}</small>
                  </div>
                </div>
              </td>
              <td>
                <span class="badge category-badge">
                  {{ member.championship_category?.name || member.match_category?.name || '-' }}
                </span>
              </td>
              <td>
                <span class="text-muted small">{{ member.age_category?.name || '-' }}</span>
              </td>
              <td>
                <div v-if="member.category_class && typeof member.category_class === 'object'">
                  <span class="fw-medium text-dark">{{ member.category_class.name }}</span>
                  <small class="text-muted d-block" style="font-size: 11px;">
                    {{ member.category_class.weight_min }}–{{ member.category_class.weight_max }} kg
                  </small>
                </div>
                <div v-else-if="nomorSeni(member)">
                  <span class="badge bg-secondary-subtle text-secondary">{{ nomorSeni(member) }}</span>
                </div>
                <div v-else class="text-muted">-</div>
              </td>
              <td>
                <span
                  v-if="(member.tournament_participants && member.tournament_participants.length > 0) || (member.tournamentParticipants && member.tournamentParticipants.length > 0)"
                  class="badge bg-success-subtle text-success d-inline-flex align-items-center gap-1 px-2.5 py-1.5 rounded-pill"
                >
                  <i class="bi bi-check-circle-fill"></i> Lunas
                </span>
                <span
                  v-else
                  class="badge bg-warning-subtle text-warning-emphasis d-inline-flex align-items-center gap-1 px-2.5 py-1.5 rounded-pill"
                >
                  <i class="bi bi-clock-fill"></i> Belum Lunas
                </span>
              </td>
              <td class="text-end pe-3">
                <MenuAksi v-slot="{ tutup }">
                  <button type="button" class="aksi__item" @click="tutup(); EditMember(member.id)">
                    <i class="bi bi-pencil-square text-primary"></i> Ubah
                  </button>
                  <button
                    type="button"
                    class="aksi__item aksi__item--bahaya"
                    v-if="bisaHapusMember(member)"
                    @click="tutup(); confirmDelete(member.id)"
                  >
                    <i class="bi bi-trash text-danger"></i> Hapus
                  </button>
                </MenuAksi>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10" class="text-center py-5">
                <div class="empty-state-box">
                  <i class="bi bi-search text-muted display-6 mb-2 d-block"></i>
                  <p class="text-dark fw-semibold mb-1">Tidak ada data atlet ditemukan</p>
                  <p class="text-muted small mb-3">Coba ubah filter pencarian atau tambahkan atlet baru.</p>
                  <button v-if="activeFilterCount > 0 || searchQuery" class="btn btn-outline-primary btn-sm" @click="resetFilter">
                    Reset Filter
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-end mt-4">
        <AppPagination
          :current-page="currentPage"
          :total-pages="totalPages"
          :prev-page-url="prevPageUrl"
          :next-page-url="nextPageUrl"
          @change-page="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { labelJK } from '@/utils/jk';
import http from "@/services/http";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import { inject } from 'vue';

export default {
  name: "MembersList",

  components: { MenuAksi, AppPagination },
  data() {
    return {
      form: {
        tournament_id: '',
        match_category_id: '',
        age_category_id: '',
        category_class_id: '',
        payment_status: '', 
      },
      tournaments: [],
      memberId: null,
      matchCategories: [],
      ageCategories: [],
      categoryClasses: [],

      deleteModal: null,
      selectedMemberIds: [],
      bulkDeleteModal: null,
      bulkDeleting: false,
      members: [], // Array to hold paginated team members
      searchQuery: "", // User's search input
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
    };
  },

  setup() {
    const toast = useToast();
    const permissions = inject('permissions', []);
    
    return { toast, permissions };
  },

  computed: {
    daftarPermissions() {
      const p = this.permissions;
      if (Array.isArray(p)) return p;
      if (p && Array.isArray(p.value)) return p.value;
      return [];
    },

    isPanitia() {
      try {
        const data = JSON.parse(localStorage.getItem('user') || '{}');
        const group = data.group?.name || '';
        return ['Owner', 'Event PIC', 'Admin'].includes(group);
      } catch (e) {
        return false;
      }
    },

    deletableMembers() {
      return (this.members || []).filter((m) => m && this.bisaHapusMember(m));
    },

    isAllSelected() {
      if (this.deletableMembers.length === 0) return false;
      return this.deletableMembers.every((m) => this.selectedMemberIds.includes(m.id));
    },

    isIndeterminate() {
      const selectedDeletable = this.deletableMembers.filter((m) => this.selectedMemberIds.includes(m.id));
      return selectedDeletable.length > 0 && selectedDeletable.length < this.deletableMembers.length;
    },

    activeFilterCount() {
      let count = 0;
      if (this.form.tournament_id) count++;
      if (this.form.match_category_id) count++;
      if (this.form.age_category_id) count++;
      if (this.form.category_class_id) count++;
      if (this.form.payment_status) count++;
      return count;
    },

    paginationRange() {
      const delta = 2;
      const range = [];
      const left = Math.max(2, this.currentPage - delta);
      const right = Math.min(this.totalPages - 1, this.currentPage + delta);

      range.push(1); // Always show first page

      if (left > 2) range.push('...');

      for (let i = left; i <= right; i++) {
        range.push(i);
      }

      if (right < this.totalPages - 1) range.push('...');

      if (this.totalPages > 1) range.push(this.totalPages); // Always show last page

      return range;
    },
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },

  mounted() {
    this.loadTournaments();
    this.loadTeamMembers();
    this.$nextTick(() => {
      const modalEl = document.getElementById("confirmDeleteModal");
      if (modalEl) {
        this.deleteModal = new Modal(modalEl);
      }
    });
  },

  methods: {
    labelJK,
    bukaCetakIdCard() {
      const query = {};
      if (this.form.tournament_id) {
        query.tournament_id = this.form.tournament_id;
      }
      this.$router.push({ path: '/admin/id-card', query });
    },

    setPaymentFilter(status) {
      this.form.payment_status = status;
      this.currentPage = 1;
      this.loadTeamMembers();
    },

    resetFilter() {
      this.form.tournament_id = '';
      this.form.match_category_id = '';
      this.form.age_category_id = '';
      this.form.category_class_id = '';
      this.form.payment_status = '';
      this.matchCategories = [];
      this.ageCategories = [];
      this.categoryClasses = [];
      this.searchQuery = '';
      this.currentPage = 1;
      this.loadTeamMembers();
    },

    clearSearch() {
      this.searchQuery = '';
      this.currentPage = 1;
      this.loadTeamMembers();
    },

    /**
     * Nomor seni atlet: Tunggal, Ganda, Regu, dan seterusnya.
     */
    nomorSeni(member) {
      if (!member || typeof member !== 'object') return null;
      const kategori = member.match_category;
      if (!kategori || typeof kategori !== 'object') return null;

      const nomor = kategori.nomor;
      if (nomor) return nomor === 'Tanding' ? null : nomor;

      const nama = String(kategori.name || '');
      const cocok = ['Solo Kreatif', 'Tunggal', 'Ganda', 'Regu', 'Tradisi']
        .find((n) => new RegExp(n, 'i').test(nama));

      return cocok || null;
    },

    async fetchMatchCategories() {
      if (!this.form.tournament_id) {
        this.matchCategories = [];
        this.form.match_category_id = '';
        this.form.age_category_id = '';
        this.form.category_class_id = '';
        this.ageCategories = [];
        this.categoryClasses = [];
        this.loadTeamMembers();
        return;
      }

      try {
        const response = await http.get(`/fetch-match-categories`, {
          params: { tournament_id: this.form.tournament_id }
        });
        const data = response.data;
        this.matchCategories = Array.isArray(data) ? data : (data?.data || []);

        // Reset dan clear turunan dropdown
        this.form.match_category_id = '';
        this.form.age_category_id = '';
        this.form.category_class_id = '';
        this.ageCategories = [];
        this.categoryClasses = [];

        this.loadTeamMembers();
      } catch (error) {
        console.error("Gagal fetch match categories:", error);
        this.matchCategories = [];
        this.loadTeamMembers();
      }
    },

    async fetchAgeCategories() {
      if (!this.form.match_category_id) {
        this.ageCategories = [];
        this.form.age_category_id = '';
        this.form.category_class_id = '';
        this.categoryClasses = [];
        this.loadTeamMembers();
        return;
      }

      try {
        const response = await http.get(`/fetch-age-categories`, {
          params: { match_category_id: this.form.match_category_id }
        });
        const data = response.data;
        this.ageCategories = Array.isArray(data) ? data : (data?.data || []);

        // Reset dan clear turunan dropdown
        this.form.age_category_id = '';
        this.form.category_class_id = '';
        this.categoryClasses = [];

        this.loadTeamMembers();
      } catch (error) {
        console.error("Gagal fetch age categories:", error);
        this.ageCategories = [];
        this.loadTeamMembers();
      }
    },

    async fetchCategoryClasses() {
      if (!this.form.age_category_id) {
        this.categoryClasses = [];
        this.form.category_class_id = '';
        this.loadTeamMembers();
        return;
      }

      try {
        const response = await http.get(`/fetch-category-classes`, {
          params: { age_category_id: this.form.age_category_id }
        });
        const data = response.data;
        this.categoryClasses = Array.isArray(data) ? data : (data?.data || []);

        // Reset selected class
        this.form.category_class_id = '';

        this.loadTeamMembers();
      } catch (error) {
        console.error("Gagal fetch class:", error);
        this.categoryClasses = [];
        this.loadTeamMembers();
      }
    },

    async loadTournaments() {
      try {
        const res = await http.get("/tournaments/active");
        const raw = res.data;
        this.tournaments = Array.isArray(raw) ? raw : (raw?.data || []);
      } catch (err) {
        console.error("Gagal load tournament:", err);
        this.tournaments = [];
      }
    },

    async exportToExcel() {
      try {
        this.loading = true;

        const response = await http.get("/team-members/export", {
          params: {
            search: (this.searchQuery || '').trim(),
            tournament_id: this.form.tournament_id || undefined,
            match_category_id: this.form.match_category_id || undefined,
            age_category_id: this.form.age_category_id || undefined,
            category_class_id: this.form.category_class_id || undefined,
            payment_status: this.form.payment_status || undefined,
          },
          responseType: "blob",
        });

        let filename = "Data_Atlet.xlsx";
        const disposition = response.headers?.["content-disposition"];
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.toast.success("Data atlet berhasil diekspor!");
      } catch (error) {
        console.error("Gagal mengekspor:", error);
        this.toast.error("Gagal mengekspor data!");
      } finally {
        this.loading = false;
      }
    },

    bisaHapusMember(member) {
      if (!member || typeof member !== 'object') return false;
      if (!this.daftarPermissions.includes('delete member')) return false;

      // Panitia (Owner, Event PIC, Admin) tetap memiliki hak kelola penuh
      if (this.isPanitia) return true;

      // Official TIDAK BISA menghapus atlet yang sudah mendaftar dan lunas / masuk peserta turnamen
      const participants = member.tournament_participants || member.tournamentParticipants || [];
      const sudahLunas = (Array.isArray(participants) && participants.length > 0)
        || member.payment_status === 'paid';
      if (sudahLunas) return false;

      return true;
    },

    confirmDelete(id) {
      this.memberId = id;
      if (!this.deleteModal) {
        const modalEl = document.getElementById("confirmDeleteModal");
        if (modalEl) {
          this.deleteModal = new Modal(modalEl);
        }
      }
      if (this.deleteModal) {
        this.deleteModal.show();
      }
    },

    async loadTeamMembers(page = 1) {
      this.loading = true;
      this.selectedMemberIds = [];
      try {
        const response = await http.get("/team-members", {
          params: {
            page,
            perPage: this.perPage,
            search: (this.searchQuery || '').trim(),
            tournament_id: this.form.tournament_id || undefined,
            match_category_id: this.form.match_category_id || undefined,
            age_category_id: this.form.age_category_id || undefined,
            category_class_id: this.form.category_class_id || undefined,
            payment_status: this.form.payment_status || undefined,
          },
        });
        const resData = response.data || {};
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = resData;

        this.members = Array.isArray(data) ? data : (Array.isArray(resData) ? resData : []);
        this.currentPage = current_page || page;
        this.totalPages = last_page || 1;
        this.nextPageUrl = next_page_url || null;
        this.prevPageUrl = prev_page_url || null;
      } catch (error) {
        console.error("Gagal load team members:", error);
        this.members = [];
        this.currentPage = 1;
        this.totalPages = 0;
        this.nextPageUrl = null;
        this.prevPageUrl = null;
      } finally {
        this.loading = false;
      }
    },

    async deleteData() {
      try {
        await http.delete(`/team-members/${this.memberId}`);
        this.$emit("memberDeleted", this.memberId);
        this.loadTeamMembers(this.currentPage);
        this.toast.success("Atlet berhasil dihapus!");
        if (this.deleteModal) this.deleteModal.hide();
      } catch (error) {
        if (this.deleteModal) this.deleteModal.hide();
        const pesan = error?.response?.data?.message || error?.friendlyMessage || "Gagal menghapus atlet.";
        this.toast.error(pesan);
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        // Uncheck all deletable on current page
        const currentIds = this.deletableMembers.map((m) => m.id);
        this.selectedMemberIds = this.selectedMemberIds.filter((id) => !currentIds.includes(id));
      } else {
        // Check all deletable on current page
        const newIds = new Set(this.selectedMemberIds);
        this.deletableMembers.forEach((m) => newIds.add(m.id));
        this.selectedMemberIds = Array.from(newIds);
      }
    },

    confirmBulkDelete() {
      if (this.selectedMemberIds.length === 0) return;
      if (!this.bulkDeleteModal) {
        const modalEl = document.getElementById("confirmBulkDeleteModal");
        if (modalEl) {
          this.bulkDeleteModal = new Modal(modalEl);
        }
      }
      if (this.bulkDeleteModal) {
        this.bulkDeleteModal.show();
      }
    },

    async deleteBulkData() {
      if (this.selectedMemberIds.length === 0) return;
      this.bulkDeleting = true;
      try {
        const res = await http.post("/team-members/bulk-delete", {
          ids: this.selectedMemberIds,
        });
        this.toast.success(res.data?.message || "Atlet terpilih berhasil dihapus!");
        this.selectedMemberIds = [];
        if (this.bulkDeleteModal) this.bulkDeleteModal.hide();
        this.loadTeamMembers(this.currentPage);
      } catch (error) {
        if (this.bulkDeleteModal) this.bulkDeleteModal.hide();
        const pesan = error?.response?.data?.message || error?.friendlyMessage || "Gagal menghapus atlet terpilih.";
        this.toast.error(pesan);
      } finally {
        this.bulkDeleting = false;
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadTeamMembers(page);
      }
    },

    searchMembers() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadTeamMembers();
    },

    async EditMember(id) {
      this.$router.push({ name: "EditMember", params: { id } });
    },
  },
};
</script>

<style scoped>
.page-main-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* ── Modern Filter Card ── */
.modern-filter-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-xl, 14px);
  padding: 1.25rem 1.5rem;
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-fast);
}

.filter-icon-box {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md, 8px);
  background: var(--accent-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: var(--accent);
}

.filter-title {
  font-size: 0.95rem;
  color: var(--text-primary);
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.filter-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0;
}

.filter-select {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--border-subtle);
  background-color: var(--bg-surface);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.filter-select:focus {
  background-color: var(--bg-surface);
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-subtle);
}

.filter-select:disabled {
  background-color: var(--bg-sunken);
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.7;
}

.filter-search-wrapper {
  border-top: 1px solid var(--border-subtle);
}

/* ── Quick Status Pills ── */
.quick-status-pills {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  gap: 0.5rem;
  scrollbar-width: none;
}

.quick-status-pills::-webkit-scrollbar {
  display: none;
}

.status-pill {
  white-space: nowrap;
  flex-shrink: 0;
  border: 1px solid var(--border-subtle);
  background: var(--bg-sunken);
  color: var(--text-secondary);
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.3rem 0.85rem;
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: all var(--transition-fast);
  display: inline-flex;
  align-items: center;
}

.status-pill:hover {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.status-pill.active {
  background: var(--accent);
  color: #ffffff;
  border-color: var(--accent);
  box-shadow: var(--shadow-sm);
}

.status-pill--paid.active {
  background: #16a34a !important;
  color: #ffffff !important;
  border-color: #15803d !important;
}

.status-pill--unpaid.active {
  background: #d97706 !important;
  color: #ffffff !important;
  border-color: #b45309 !important;
}

@media (max-width: 640px) {
  .header-section .d-flex.flex-wrap.gap-2 {
    width: 100%;
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem !important;
  }
  .header-section .d-flex.flex-wrap.gap-2 > a:last-child,
  .header-section .d-flex.flex-wrap.gap-2 > button:last-child {
    grid-column: span 2;
    justify-content: center;
  }
}

/* ── Search Input Group ── */
.search-input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 14px;
  font-size: 0.9rem;
  pointer-events: none;
  z-index: 2;
}

.search-input {
  padding-left: 2.5rem !important;
  padding-right: 2.2rem !important;
  border-radius: 9px;
  font-size: 0.875rem;
  background: var(--bg-surface);
  border: 1px solid var(--border-strong);
  color: var(--text-primary);
}

.search-input:focus {
  background: var(--bg-surface);
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-subtle);
}

.btn-clear-search {
  position: absolute;
  right: 10px;
  font-size: 0.9rem;
}

/* ── Table Styling ── */
.modern-table-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  overflow-x: auto !important;
  box-shadow: var(--shadow-sm);
}

.modern-table-card .table th {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  background: var(--bg-sunken);
  padding: 0.85rem 0.75rem;
  border-bottom: 1px solid var(--border-subtle);
}

.modern-table-card .table td {
  padding: 0.85rem 0.75rem;
  font-size: 0.875rem;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-subtle);
}

.table-row-hover:hover {
  background-color: var(--bg-hover);
}

.avatar-circle {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: var(--grad-flame-soft);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.82rem;
  font-weight: 700;
}

.category-badge {
  background: var(--accent-subtle);
  color: var(--text-brand);
  border: 1px solid var(--border-subtle);
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: var(--grad-flame-soft);
  animation: loader-animation 1.5s infinite;
}

@keyframes loader-animation {
  0% { width: 0; }
  50% { width: 50%; }
  100% { width: 100%; }
}
</style>
